<template>
  <div id="ui-view">
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">Search Invoices</span>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-2">
                    <div class="form-group">
                    <label for="name">To Date</label><br>
                    <date-picker editable lang="en" v-model="todate"></date-picker>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">From Date</label><br>
                    <date-picker editable lang="en" v-model="fromdate"></date-picker>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="name">Customer Name</label>
                    <input type="text" class="form-control" autocomplete="off"  placeholder="Enter Your Customer Name" v-model="custname">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label for="name">Sale Id</label>
                    <input type="text" class="form-control" autocomplete="off"   placeholder="Enter Your SaleId" v-model="salename">
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label for="name">&nbsp;</label><br>
                    <button type="submit" class="btn btn-primary serach_bttn" @click="searchdt">
                      <i class="fa fa-search"></i>&nbsp;Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <span class="title_head">Invoice List</span>
            </div>
            <div class="card-body">
              <vue-good-table
               :columns="columns"
               :rows="rows"
               :pagination-options="{enabled: true, perPage: 5, }"
                mode="remote"
                ref="my-table"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'generate'">
                    <button @click="generateclick(props.row)" style=" width:80px; border-radius: 20px" class="btn btn-sm btn-primary">Invoice</button>
                  </span>
                  <span v-else-if="props.column.field == 'lastupdated_datetime'">
                      {{newDate(props.row.lastupdated_datetime)}}
                </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
      <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
  import Spinner from '../../spinner.vue'
  import DatePicker from 'vue2-datepicker'
  export default {
    name:'Invoice',
    components: {
      'date-picker':  DatePicker,Spinner
    },
    data () {
      return {
        todate:null,
        fromdate:null,
        custname:'',
        salename:'',
        saleid:null,
        loading:false,
        totalRecords: 0,
        serverParams: {
        columnFilters: {
                   },
        sort: {
          // field: 'purchase_id', 
          // type: 'asc',
              },
        page: 1, 
        perPage: 5
      },
        columns: [
        {
          label: 'Sale Id',
          field: 'sales_id',
          width: '5% !important'
        },
        {
          label: 'Customer Company Name',
          field: 'cust_cmp_name',
          width: '20% !important'
        },
        {
         label: 'Shop',
         field: 'est_shop_name',
         width: '20% !important'
        },
        {
          label: 'Total Tax Amt',
          field: 'total_tax_amt',
          formatFn: this.formatFn,
          width: '10% !important'
        },
        {
          label: 'Total Pay Amt',
          field: 'total_amt_pay',
          formatFn: this.formatFn,
          width: '15% !important'
        },
        {
          label: 'Date',
          field: 'lastupdated_datetime',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
          dateOutputFormat: 'Do MMM YYYY',
          width: '20% !important',
          tdClass: 'text-left',
          thClass: 'text-left',
        },
        {
          label: 'Generate',
          field: 'generate',
          width: '10% !important'          
        },
      ],
      rows: [],
    }
  },
  created(){
    this.tabledt();
    this.shopuser();
  },
  methods:{
     newDate(date1)
       {
         var dt1 =  new Date(date1)
         var year=dt1.getFullYear()
         var month=dt1.getMonth()+1;
         var day=dt1.getDate();
         if(day<10){
          day='0'+day;

         }
         if(month<10){
          month='0'+month;
         }
          var dt2 = day+'-'+month+'-'+year
         // var dt2 = year+'-'+month+'-'+day
         return dt2
        },
    updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
  
           this.updateParams({page: params.currentPage});
           this.tabledt()
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.tabledt()
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.tabledt()
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.tabledt()
    },

    shopuser(){
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){

      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },
    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    generateclick(data){
      let routeData = this.$router.resolve({name: 'Sale Invoice Pdf', query: {sid: data.sales_id,cid:data.customer_id}});
      window.open(routeData.href, '_blank');
      // this.$router.props=[data.sales_id,data.customer_id]
      // this.$router.push('/saleinvoice/saleinvoicepdf')
    },
    tabledt(){
      var _this=this
      this.loading = true
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var _this=this
      var data=[];
      this.rows=[];
      var num=/^[0-9]{1}$/
      var dateto = new Date(this.todate)
      var year=dateto.getFullYear()
      var month=dateto.getMonth()+1;
      var day=dateto.getDate();

      if(num.test(month)==true){
        var month='0'+month
      }else{
        var month=month
      }

      if(num.test(day)==true){
        var day='0'+day
      }else{
        var day=day
      }

      var datefrom= new Date(this.fromdate)
      var year1=datefrom.getFullYear()
      var month1=datefrom.getMonth()+1;
      var daycon=datefrom.getDate();
      if(num.test(month1)==true){
        var month1='0'+month1
      }else{
        var month1=month1
      }

      if(num.test(daycon)==true){
        var day1='0'+daycon
      }else{
        var day1=daycon
      }

      var  todate1=year+'-'+month+'-'+day
      var  fromdate1=year1+'-'+month1+'-'+day1
      var custnameserach = this.custname
      custnameserach = custnameserach.split(' ').join('_')

      if(this.todate!=null && this.fromdate!=null){
        data=data+"&filter[where][lastupdated_datetime][between][0]="+todate1+"&filter[where][lastupdated_datetime][between][1]="+fromdate1
      }
      else{
             if(this.todate!=null){
              data= data+"&filter[where][lastupdated_datetime]="+todate1
            }
              if(this.fromdate!=null){
              data= data+"&filter[where][lastupdated_datetime]="+fromdate1
            }
      }
      if(this.custname!=''){
        data= data+"&filter[where][cust_cmp_name]="+custnameserach
      }
      if(this.salename!=''){
        data= data+"&filter[where][sales_id]="+this.salename
      }

      this.$http.get('/api/saledetails/getSales?params='+JSON.stringify(filteParam)+data).then(function(response){
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
          _this.rows=response.data;
          _this.loading=false
      }).catch(function(error){
        console.log(error)
        _this.loading=false
      })
    },
    searchdt(){

     this.updateParams({
        sort: {
          type: '',
          field: '',
        },page:1
      });
    this.$refs['my-table'].reset()
    this.tabledt()
      
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/views/sales/saleinvoice.vue